import { useEffect, useState } from "react";
import { Space, Spin, Grid, Input, Collapse, Button, Flex } from "antd";
import { LoadingOutlined, CaretRightOutlined } from "@ant-design/icons";

import { getFaqItems } from "../../../Components/Common/faqData";
import { useNavigate } from "react-router-dom";

const { useBreakpoint } = Grid;
const { Search } = Input;

const FAQ = () => {
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const [isLoading, setIsLoading] = useState(false);
  const [faqData, setFaqData] = useState([]);
  const [faqDataCategory, setFaqDataCategory] = useState([]);

  const [activeCategory, setActiveCategory] = useState();

  useEffect(() => {
    setIsLoading(true);

    let faqData = getFaqItems();

    setFaqData(faqData);

    let faqCategories = [...new Set(faqData.map((s) => s.category))];

    setFaqDataCategory(faqCategories);

    setIsLoading(false);
  }, []);

  const handleCategoryChange = (category) => {
    // if same unselected category and show all faq
    if (activeCategory === category) {
      setActiveCategory();

      setFaqData(getFaqItems());

      return;
    }

    setActiveCategory(category);

    // filter the FAQ items based on the selected category
    const filteredItems = getFaqItems().filter(
      (item) => item.category === category
    );

    // Update the state with the filtered items
    setFaqData(filteredItems);
  };

  const handleOnSearch = (value) => {
    setActiveCategory();

    const filteredItems = getFaqItems().filter((item) =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );

    setFaqData(filteredItems);
  };

  return (
    <Space
      direction="vertical"
      className="page-container"
      style={{
        width: screens.xs ? "100%" : "70%",
        marginLeft: screens.xs ? "auto" : "15%",
      }}
    >
      <Spin
        spinning={isLoading}
        indicator={<LoadingOutlined spin />}
        fullscreen
      />

      <h2
        style={{
          fontSize: screens.xs ? 26 : 36,
          fontWeight: 700,
          color: "#002753",
          marginTop: screens.xs ? 0 : 20,
          marginBottom: 15,
        }}
      >
        Frequently Asked Questions
      </h2>

      <Search
        placeholder="Search FAQs"
        onSearch={(value) => handleOnSearch(value)}
        onChange={(e) => handleOnSearch(e.target.value)}
      />

      <Space style={{ width: "100%", marginBottom: 10, marginTop: 10 }} wrap>
        {faqDataCategory.map((cat) => {
          const isActive = activeCategory === cat;

          return (
            <Button
              key={cat}
              shape="round"
              onClick={() => handleCategoryChange(cat)}
              style={{
                color: isActive ? "#002753" : "#4B5563",
                borderColor: isActive ? "#FFD600" : "#F3F4F6",
                backgroundColor: isActive ? "#FFD600" : "#F3F4F6",
                fontSize: 16,
                fontWeight: isActive ? 600 : 400,
              }}
            >
              {cat}
            </Button>
          );
        })}
      </Space>

      <Collapse
        accordion
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        items={faqData}
      />

      <Flex vertical style={{ width: "100%", marginTop: 60 }} justify="center">
        <h2
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: "#002753",
            marginTop: 0,
            marginBottom: 0,
            textAlign: "center",
          }}
        >
          Can't find what you're looking for?
        </h2>

        <Button
          type="primary"
          style={{
            marginTop: 12,
            padding: 20,
            borderRadius: 8,
            fontWeight: 600,
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto",
            fontSize: 16,
            color: "#002753",
          }}
          onClick={() => {
            navigate("/contact-us");
          }}
        >
          Contact Support
        </Button>
      </Flex>
    </Space>
  );
};

export default FAQ;
